import React, { useState, useEffect } from 'react'
import Select from 'react-select';
import { Table, Button, Badge, Dropdown, DropdownToggle, DropdownItem, DropdownMenu, InputGroup, InputGroupText, Input } from 'reactstrap';

export default function BusinessSeller({ firstName, setFirstName, lastName, setLastName, adress, setAdress, zipcode, setZipCode, city, setCity, country, setCountry, email, setEmail, phone, setPhone, companyName, setCompanyName, addressLine2, setAddressLine2,
    kontoinhaber, setKontoinhaber, iban, setIban, bic, setBic, bSellerComponentReset, nameDerBank, setNameDerBank,
}) {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdowntoggle = () =>
        setDropdownOpen((prevState) => !prevState);
    const [bSellerdropdownValue, setBSellerDropdownValue] = useState("Bitte wählen Sie den Verkäufernamen*");
    const [businessSellerInfo, setBusinessSellerInfo] = useState([]);
    const [businessSellerContactData, setBusinessSellerContactData] = useState([]);


    //const [businessSellerContactData, setBusinessSellerContactData] = useState([{ 
    //  address: '', line1: '', land: '', kontoinhaber: '', iban:'', bic: '', nameOfBank: '' 
    //}]);


    const handleBusinessSellerContactData = (fName, lName, address, line1, countryCode, kontoinhaber, iban, bic, nameOfBank, bSellerInfo) => {

        setBSellerDropdownValue(bSellerInfo.firstName + '' + bSellerInfo.lastName)

        setFirstName(fName);
        setLastName(lName);
        setAdress(address);
        setCountry(countryCode);
        setCompanyName(bSellerInfo.companyName);
        setEmail(bSellerInfo.email);
        setPhone(bSellerInfo.phone);
        setCity(bSellerInfo.address.city);
        setZipCode(bSellerInfo.address.postalCode);
        setAddressLine2(bSellerInfo.address.addressLine2);
        setKontoinhaber(bSellerInfo.bankAccountInfo.accountHolder);
        setIban(bSellerInfo.bankAccountInfo.accountNumber);
        setBic(bSellerInfo.bankAccountInfo.bankCode);

        var copyOfbusinessSellerContactData = [...businessSellerContactData];
        copyOfbusinessSellerContactData.address = address;
        copyOfbusinessSellerContactData.line1 = line1;
        copyOfbusinessSellerContactData.countryCode = countryCode;
        copyOfbusinessSellerContactData.kontoinhaber = kontoinhaber;
        copyOfbusinessSellerContactData.iban = iban;
        copyOfbusinessSellerContactData.bic = bic;
        copyOfbusinessSellerContactData.nameOfBank = nameOfBank;
        setBusinessSellerContactData(copyOfbusinessSellerContactData);
        console.log(copyOfbusinessSellerContactData)
    }
    const getBusinessSellerNames = async () => {
        try {
            const response = await fetch(
                "/api/customers/dealers/",
                {
                    method: "get",
                    headers: new Headers({
                        "Content-Type": "application/json",
                    }),
                }
            );
            const payload = await response.json();
            setBusinessSellerInfo(payload);
            console.log(payload)
            if (!response.ok) {
                const payload = await response.text();
                alert(payload);
            }
            if (response.ok) {
                payload.forEach((element, index) => {
                    var sellerNameTemp = element.firstName + ' ' + element.lastName + ' ' + element.companyName
                    sellerNamesOptions.push({ value: index, label: sellerNameTemp })
                });
                setRealSellerNamesOptions(sellerNamesOptions)
            }
        } catch (e) {
            console.log(e);
        }
    };
    useEffect(() => {
        getBusinessSellerNames();
       // sellerNamesHandlerForSelect();
      //  setBSellerDropdownValue("Bitte wählen Sie den Verkäufernamen")
    }, [bSellerComponentReset])
    const sellerNamesOptions = []
    const [realSellerNamesOptions, setRealSellerNamesOptions] = useState()
    var sellerNamesForOption
   /** const sellerNamesHandlerForSelect = () => {
            businessSellerInfo.forEach((element, index) => {
                var sellerNameTemp = element.firstName + ' ' + element.lastName
                sellerNamesOptions.push({ value: index, label: sellerNameTemp })
            });
            setRealSellerNamesOptions(sellerNamesOptions)
    } */
    const handleChangeOnBSellerName = (selectedName) => {
        if (!selectedName) {
            setFirstName('');
            setLastName('');
            setAdress('');
            setCountry('');
            setCompanyName('');
            setEmail('');
            setPhone('');
            setCity('');
            setZipCode('');
            setAddressLine2('');
            setKontoinhaber('');
            setIban('');
            setBic('');
            setNameDerBank('')
        }
        businessSellerInfo.forEach((element, index) => {
            var sellerNameTemp = element.firstName + ' ' + element.lastName + ' ' + element.companyName
            if(selectedName) {
            if (selectedName.label === sellerNameTemp) {
                setFirstName(element.firstName);
                setLastName(element.lastName);
                setAdress(element.address.addressLine1);
                setCountry(element.address.countryCode);
                setCompanyName(element.companyName);
                setEmail(element.email);
                setPhone(element.phone);
                setCity(element.address.city);
                setZipCode(element.address.postalCode);
                setAddressLine2(element.address.addressLine2);
                setKontoinhaber(element.bankAccountInfo.accountHolder);
                setIban(element.bankAccountInfo.accountNumber);
                setBic(element.bankAccountInfo.bankCode);
                setNameDerBank(element.bankAccountInfo.bankName);
            }
        }
        });
    }
    return (
        <div>
            <h5 className="mb-4">Kundeninfo</h5>
            <div className='mb-4'>
                {/* <h6 className='mr-2'>Seller Name:</h6>*/}
               {/** <Dropdown className="mr-5"
                    isOpen={dropdownOpen}
                    toggle={dropdowntoggle}>
                    <DropdownToggle caret>
                        {bSellerdropdownValue}
                    </DropdownToggle>
                    <DropdownMenu style={{ maxHeight: '500px', overflow: 'auto' }}>
                        {businessSellerInfo.map((bSellerInfo, index) => {
                          //  sellerNamesForOption.push(sellerNameTemp)
                            return (
                                <DropdownItem key={index}
                                    onClick={() => {
                                        handleBusinessSellerContactData(bSellerInfo.firstName, bSellerInfo.lastName, bSellerInfo.address.addressLine1, bSellerInfo.address.addressLine2, bSellerInfo.address.countryCode,
                                            bSellerInfo.bankAccountInfo.accountHolder, bSellerInfo.bankAccountInfo.accountNumber, bSellerInfo.bankAccountInfo.bankCode, bSellerInfo.bankAccountInfo.bankName, bSellerInfo
                                        )
                                    }}>
                                    {bSellerInfo.firstName + ' ' + bSellerInfo.lastName}
                                </DropdownItem>
                            )
                        })}
                    </DropdownMenu>
                </Dropdown>
 */}


                <Select style={{ maxHeight: '500px', overflow: 'auto'}}
                    className='w-50'
                    isClearable
                    onChange={(value) => handleChangeOnBSellerName(value)}
                    options={realSellerNamesOptions}
                    //value={roleValue}
                    //styles={customStyles}
                    placeholder="Bitte wählen Sie den Verkäufernamen*"
                >

                    </Select>
            </div>
            <div className="d-flex justify-content-evenly">
                <p className="mr-5">
                    <b className="mr-2">
                        Abholadresse:
                    </b>
                    <em>{
                        //businessSellerContactData ? businessSellerContactData.address: ''
                        adress
                    }</em>
                </p>
                <p className="mr-5" >
                    <b className="mr-2">
                        Zeile 1:
                    </b>
                    <em>{
                    //businessSellerContactData ? businessSellerContactData.line1 : ''
                    addressLine2
                    }</em>
                </p>
                <p>
                    <b className="mr-2">
                        Land:
                    </b>
                    <em>{
                    //businessSellerContactData ? businessSellerContactData.countryCode : ''
                    country
                    }</em>
                </p>
            </div>
            <div className="d-flex justify-content-between mb-4 flex-wrap">
                <p className="mr-5">
                    <b className="mr-2">
                        Kontoinhaber:
                    </b>
                    <em>{
                    //businessSellerContactData ? businessSellerContactData.kontoinhaber : ''
                    kontoinhaber
                    }</em>
                </p>
                <p className="mr-5" >
                    <b className="mr-2">
                        IBAN:
                    </b>
                    <em>{
                    //businessSellerContactData ? businessSellerContactData.iban : ''
                iban
                }</em>
                </p>
                <p className="mr-5">
                    <b className="mr-2">
                        BIC:
                    </b>
                    <em>{
                    //businessSellerContactData ? businessSellerContactData.bic : ''
                    bic
                }</em>
                </p>
                <p>
                    <b className="mr-2">
                        Name der Bank:
                    </b>
                    <em>{
                   // businessSellerContactData ? businessSellerContactData.nameOfBank : ''
                   nameDerBank
                    }</em>
                </p>
            </div>
        </div>
    )
}
